export default __webpack_public_path__ + "static/media/about-logo.7a662311.svg";